import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebsitesClicks = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 51.29527 51.29527",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "websitesClicks" }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M28.51226,8.19508l3.92382-3.92382a10.3152,10.3152,0,0,1,14.58792,0h0a10.3152,10.3152,0,0,1,0,14.58792L34.45816,31.425a10.31522,10.31522,0,0,1-14.58792,0",
		style: {
			fill: "none",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.13607,42.74713,18.85919,47.024a10.3152,10.3152,0,0,1-14.58792,0h0a10.3152,10.3152,0,0,1,0-14.58792L16.83711,19.87023a10.31522,10.31522,0,0,1,14.58792,0h0",
		style: {
			fill: "none",
			stroke: "#454545",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})] })]
});
export default SvgWebsitesClicks;
